import { fromJS } from 'immutable';

import { ApiDashboard,UserToken } from '../../../helper/HelperAuth'
import {GetReadRateByTime} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'


export default (body, type=null) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiDashboard + 'read-rate-by-time';

    var query = body

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            'template-type':type,

        },
        body : JSON.stringify(query)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    var responseData = [];
    var finalData = [];
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('read-rate-by-time');
        for (var i = 0; i < data.size; i++) {
            responseData = []
            let dataDetail = data.get(i)
            responseData['name'] = dataDetail.get('jam').substring(0, 2)
            responseData['read'] = parseInt(dataDetail.get('total-read'))
            finalData.push(responseData)
        }
        data = finalData
    }
    dispatch({ type: GetReadRateByTime, data:data });
    return data
};